import React from 'react'
import { withTheme } from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'
import Modal from 'components/lib/DesignSystem/Modal'

class NewRelease extends React.Component {
  state = {
    closed: false,
  }

  handlerOnClose = () => {
    if (!this.state.closed) this.handlerLastSeenSave()
  }

  handlerLastSeenSave = () => {
    this.setState({ closed: true })
    this.props.saveLastSeenProductRelease()
  }

  handlerLearnMore = () => {
    const { lastProductRelease } = this.props
    window.open(lastProductRelease.url, '_blank')
    this.handlerLastSeenSave()
  }

  render() {
    const { closed } = this.state
    const { theme, isMaster, lastProductRelease, lastSeenProductRelease, environment } = this.props

    if (
      closed ||
      isMaster ||
      !lastProductRelease ||
      environment === 'ONPREMISE' ||
      window.innerWidth <= parseInt(theme.rcPhonePoint) ||
      new Date(lastSeenProductRelease) >= new Date(lastProductRelease.created)
    )
      return ''

    return (
      <Modal
        width="540px"
        title={`Version ${lastProductRelease?.version} is live`}
        onClose={this.handlerOnClose}
        open
        footer={
          <>
            <Button
              text="Close"
              onClick={this.handlerLastSeenSave}
              className="mr"
              styleType="secondary"
              id="New_Release_Close_Btn"
            />
            <Button
              text="Read More"
              onClick={this.handlerLearnMore}
              id="New_Release_Read_More_Btn"
            />
          </>
        }
        id="New_Release_Modal"
      >
        <>
          <img src="/static/webapp/images/new-release.svg" className="ma db" />
          <div style={{ marginTop: '32px' }}>
            {`We are excited to announce a new product version ${lastProductRelease?.version}`}
            <br />
            We would like to invite you to submit a review on{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://gtnr.it/2ZeAwWe"
              className="link-new-design"
              id="New_Release_Review_Link"
            >
              Gartner Peer Insight.
            </a>
            <br />
            We appreciate your review!
          </div>
        </>
      </Modal>
    )
  }
}

export default withTheme(NewRelease)
